export default __webpack_public_path__ + "static/media/3.143c12df.jpg";